import { useRef, useCallback } from "react";

const FREE = "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free";

// Returns lookup(postal, number, target); calls onFound({street, city, postal_code}, target) via PDOK.
export default function usePostcodeLookup(onFound) {
  const timer = useRef(null);
  const cb = useRef(onFound);
  cb.current = onFound;
  return useCallback((postal, number, target) => {
    clearTimeout(timer.current);
    const pc = String(postal || "").replace(/\s/g, "").toUpperCase();
    const nr = String(number || "").trim().match(/^\d+/)?.[0];
    if (!/^\d{4}[A-Z]{2}$/.test(pc) || !nr) return;
    timer.current = setTimeout(async () => {
      try {
        const q = encodeURIComponent(`postcode:${pc} AND huisnummer:${nr}`);
        const r = await fetch(`${FREE}?q=${q}&fq=type:adres&fl=straatnaam,woonplaatsnaam,postcode&rows=1`);
        const a = (await r.json())?.response?.docs?.[0];
        if (a?.straatnaam) cb.current({ street: a.straatnaam, city: a.woonplaatsnaam || "", postal_code: a.postcode || pc }, target);
      } catch {}
    }, 400);
  }, []);
}
